import { FC } from 'react';
import classNames from 'classnames';
import { CarouselItem } from 'v3/pages/LandingPage/types.type';
import { bannerTexts } from 'v3/pages/LandingPage/config.ts';
import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

type TextCarouselProps = {
  isShowing: boolean;
  currentIndex: number;
  productName: string;
};

const TextCarousel: FC<TextCarouselProps> = ({ isShowing, currentIndex, productName }) => {
  const combinedColorClassName = classNames('homepage-carousel__circle', {
    blue: currentIndex === 0,
    red: currentIndex === 1,
    yellow: currentIndex === 2,
  });

  const renderText = (item: CarouselItem, index: number) => {
    const isCurrent = index === currentIndex;
    const combinedClassNames = classNames('homepage-carousel__fade-text', {
      show: isCurrent && isShowing,
      exit: isCurrent && !isShowing,
    });

    return (
      <div key={index} className={combinedClassNames}>
        <span className={item.colorClass}>{item.text}</span>
        <img src={item.icon} alt="" />
      </div>
    );
  };
  return (
    <div className="homepage-carousel-container">
      <div className="homepage-carousel">
        <div className={combinedColorClassName} />
        {_.map(bannerTexts, renderText)}
      </div>
      <h4 className="subheadline">with {_.capitalize(ApplicationDomainUtility.partnerName) || productName}</h4>
    </div>
  );
};

export default TextCarousel;
